export const siteSettings = {
  name: "Anchor Capitals",
  link: "https://anchorcapitals.com",
  email: "support@anchorcapitals.com",
  appLink: "https://app.anchorcapitals.com",
};
